export default "__VITE_ASSET__c12dc6bc__"